var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.phoneType},[_vm._v(_vm._s(_vm.phone.type))]),_vm._v(" "),_c('div',{class:_vm.$style.phoneNumber},[_vm._v(_vm._s(_vm.phone.nationalFormat))]),_vm._v(" "),_c('ContactButtons',{attrs:{"contact":_vm.contact,"phone":_vm.phone}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-429efc7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SearchContacts/SearchMode/PhoneNumber.vue
// module id = tsV2
// module chunks = 1